<template>
    <div class="p14">
        <div class="flex jcsb m-b9">
            <div class="flex" >
                <span class="datetxt">姓名:</span>
                <el-select  class="inputwidth" size="mini"  style="width:130px;" @change="nameChange" clearable filterable remote :remote-method="namesearch"  v-model="personid">
                    <el-option v-for="(val,index) in searchPeople"  :label="val.name+'('+val.department+')'" :value="val.id"></el-option>
                </el-select>
                <el-date-picker  style="width:110px;" class="m-l14" size="mini" :clearable="false" v-model="month" type="month" placeholder="选择月" format="yyyy-MM" value-format="yyyy-MM" @change="changeMonth"></el-date-picker>
                <el-button class="mrl20" style="margin-left: 10px" icon="el-icon-search" circle  @click="searchFun" size="mini"></el-button>
                <el-button :class="['m-l14',baseerp+'btn']" type="primary" :disabled="!personid" size="mini" @click="add">新增</el-button>
                <el-button :class="baseerp+'btn'" type="primary" v-if="!canEdit" :disabled="canEdit||tableData.length==0" size="mini" @click="edit">编辑</el-button>
                <el-button :class="baseerp+'btn'" type="primary" v-if="canEdit" size="mini" @click="noedit">取消</el-button>
                <el-button :class="baseerp+'btn'" type="success" :disabled="!canSave" size="mini" @click="editSave">{{$t('button_save')}}</el-button>
                <el-button  type="danger"  size="mini" @click="qtscFun('add')">受理加班申请</el-button>
<!--                <el-button  type="danger"  size="mini" @click="qtscFun('bkadd')">受理补卡申请</el-button>-->
            </div>
            <div>
                <el-select @change="kqdataChange"  class="m-l14"  style="width:120px;" size="mini" v-model="kqdata" slot="prepend" placeholder="请选择">
                    <el-option v-for="val in kaoqinList" :key="val.i_id" :label='val.vc_tcname' :value="val.vc_tcname"></el-option>
                </el-select>
                <el-button  class="m-l14"  size="mini" :disabled="!month" @click="workovertime" type="primary">加班异常</el-button>
                <el-button  class="m-l14"  size="mini" :disabled="!personid||!month" @click="workovertimeSy" type="primary">加班使用明细</el-button>
                <el-button  class="m-l14"  size="mini" :disabled="!month" @click="workovertimeZl" type="primary">加班总览</el-button>
            </div>
        </div>
        <el-table  ref="table" :header-cell-style="{background:'#f5f7fa',color:'#000'}" size="mini" :height="tableHeight" border  :data="tableData" style="width: initial;">
<!--            <el-table-column type="selection" align="center"></el-table-column>-->
<!--            <el-table-column align="center" label="日期" prop="forDate">-->
<!--                <template class="flex"  slot-scope="scope">-->
<!--                    <el-date-picker class="m-l14" size="mini" v-model="scope.row.date" type="month" placeholder="选择日" format="yyyy-MM" value-format="yyyy-MM"></el-date-picker>-->

<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column align="center" label="姓名" prop="userName" width="70" show-overflow-tooltip>
                <template class="flex"  slot-scope="scope">
                    <el-button type="text"  @click="qtscFun('name',scope.row)">{{scope.row.userName}}</el-button>
                </template>
            </el-table-column>

            <el-table-column align="center" label="识别码" prop="vc_code"  show-overflow-tooltip>
                <template class="flex"  slot-scope="scope">
                    <span style="cursor: pointer" @click="qtscFun('code',scope.row)">{{scope.row.vc_code}}</span>
                </template>
            </el-table-column>
<!--            <el-table-column align="center" label="补卡识别码" prop="vc_bk_code"  show-overflow-tooltip>-->
<!--                <template class="flex"  slot-scope="scope">-->
<!--                    <el-button type="text"  @click="qtscFun('bkcode',scope.row)">{{scope.row.vc_bk_code}}</el-button>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column align="center" label="状态" prop="confirmedTxt" width="90">
                <template class="flex"  slot-scope="scope">
                    <span :class="(scope.row.i_isconfirmed==-1||scope.row.i_isconfirmed==-2)?'red':(scope.row.i_isconfirmed==0)?'blue':'green'">{{scope.row.confirmedTxt}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="加班类型" width="140" prop="overtimeType">
                <template class="flex"  slot-scope="scope">
                    <template>
                        <div v-show="(canEdit||scope.row.subId==0)&&scope.row.i_isfrom!=1">
                            <el-radio-group v-removeAria ref="radio" v-model="scope.row.overtimeType"  @input="scope.row.change='change'">
                                <el-radio :label=2  >调休</el-radio>
                                <el-radio  :label=1 >薪资</el-radio>
                            </el-radio-group>
                        </div>

                        <span v-show="!((canEdit||scope.row.subId==0)&&scope.row.i_isfrom!=1)">{{scope.row.overtimeType==1?'薪资':'调休'}}</span>

                    </template>

                </template>
            </el-table-column>
            <el-table-column align="center" label="开始时间" prop="startTime"  show-overflow-tooltip>
                    <template class="flex"  slot-scope="scope">
                        <el-date-picker style="width: initial;" v-if="(canEdit||scope.row.subId==0)&&scope.row.i_isfrom!=1"  @change="startTimeChange($event,scope.row)" size="mini" v-model="scope.row.startTime" type="datetime" placeholder="选择开始时间" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
                        <span v-else>{{scope.row.startTime}}</span>
                    </template>
            </el-table-column>
            <el-table-column align="center" label="结束时间" prop="endTime"  show-overflow-tooltip>
                <template class="flex"  slot-scope="scope">
                    <el-date-picker style="width: initial;" v-if="(canEdit||scope.row.subId==0)&&scope.row.i_isfrom!=1"  @change="endTimeChange($event,scope.row)" size="mini" v-model="scope.row.endTime" type="datetime" placeholder="选择结束时间" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
                    <span v-else>{{scope.row.endTime}}</span>

                </template>
            </el-table-column>
            <el-table-column align="center" label="时长" prop="overtimeHour">
                <template class="flex"  slot-scope="scope">
                    <el-input-number style="width: initial;" v-if="(canEdit||scope.row.subId==0)&&scope.row.i_isfrom!=1"  @change="scope.row.change='change'"  :precision="1" v-model="scope.row.overtimeHour"  size="mini" :step="0.5" :min="0.5" :controls="false" :step-strictly="true"></el-input-number>
                    <span v-else>{{scope.row.overtimeHour}}</span>
<!--                    <el-input-number :controls="false" v-if="scope.row.edit" :precision="1" :step="0.5" :step-strictly="true" v-model="scope.row.i_shouldattend" :min="1"  style="width:140px">-->
<!--                    </el-input-number>-->
                </template>
            </el-table-column>
            <el-table-column align="center" label="是否补卡" prop="i_isbk" width="70" show-overflow-tooltip>
                <template class="flex"  slot-scope="scope">
                    <span >{{scope.row.i_isbk==1?'是':'否'}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="是否用完" prop="i_over" width="70" show-overflow-tooltip>
                <template class="flex"  slot-scope="scope">
                    <span >{{scope.row.i_over==1?'是':'否'}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="录入人" prop="vc_lruname" width="90"></el-table-column>
            <el-table-column align="center" label="录入时间" prop="dt_createtime" width="100"></el-table-column>
            <el-table-column align="center" label="操作(保存后生效)" width="120" >
                <template class="flex"  slot-scope="scope">
                   <el-button type="text" style="color: red" v-if="scope.row.i_isfrom!=1&&scope.row.vc_code==''" @click="delFun(scope.row,scope.$index)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  style="margin-top: 10px;text-align: right"
                        background
                        @current-change="pageCurrentChange"
                        layout="total,prev, pager, next"
                        :current-page.sync="currentPage"
                        :total="total"
                        :page-size="pageSize">
        </el-pagination>
        <div class="contentLeft">
            <reportdialog  ref="mydialog"   ></reportdialog>
            <eDialog ref="eDialog" :activePage="activePage"></eDialog>
        </div>
        <div :class="baseerp+'div'">
            <el-dialog :title="(propData.type=='bkadd'||propData.type=='bkcode')?'受理补卡申请':'受理加班申请'"
                       width="95%"
                       top="30px"
                       :visible.sync="dialogSub"
                       :close-on-click-modal="false"
                       @close="closeSubFun">

                <sub-list :data="propData" v-if="dialogSub" @close="closeSubFun" ></sub-list>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import reportdialog from "@/components/dialog"; // dialog
    import eDialog from "@/components/eDialog"; // dialog
    import {mapActions} from "vuex";
    import SubList from './SubIndex'

    const getYm=()=>{
        let newD=new Date();
        let y=newD.getFullYear();
        let m=newD.getMonth()+1;
            m=m>9? m : '0'+m;
        return y+'-'+m
    };
    export default {

        name: "jiaBan",
        components:{
            eDialog,
            reportdialog,SubList
        },
        data(){
            return{
                baseerp:baseerp,
                searchname:'',
                searchPeople:[],
                month:getYm(),
                personid:null,
                disabled:false,
                tableHeight:0,//列表高度
                tableData:[],
                multipleSelection:[],
                currentPage:1,
                pageSize:20,
                total:0,
                canEdit:false,
                canSave:false,
                dialogSub:false,
                delList:[],
                activePage:"report/res/spread.vue",
                djmark:'',//考勤方案
                kaoqinList:[],
                kaoqini_id:0,
                kqdata:'',
                propData:{},
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted(){
            // this.$refs.radio.$children.forEach(item=>{
            //     item.$refs.radio.removeAttribute('aria-hidden')
            // })
            this.searchUser()
            this.getKqList()
            this.overtimeList()
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100
            },
            qtscFun(type,data={}){
                this.propData={
                    type:type,
                    data:data
                }
                this.dialogSub=true
            },
            closeSubFun(type='back'){
                if(type=='save'){
                    this.currentPage=1;
                    //调用列表接口
                    this.overtimeList();
                }
                this.dialogSub=false
            },
            startTimeChange(e,row){
                row.change='change';
                if(row.endTime){
                    let end=new Date(row.endTime+':00'),start=new Date(row.startTime+':00'),
                        dif=end - start;
                    if(dif>24*60*60*1000||dif<=0){
                        this.$message.error('时间区间需大于0小于等于24')
                        row.startTime=''
                    }
                }
            },
            endTimeChange(e,row){
                row.change='change';
                if(row.startTime){
                    let end=new Date(row.endTime+':00'),start=new Date(row.startTime+':00'),
                        dif=end - start;
                    if(dif>24*60*60*1000||dif<=0){
                        this.$message.error('时间区间需大于0小于等于24')
                        row.endTime=''
                    }
                }
            },

            //延迟搜索
            namesearch(val){
                this.searchname=val
                this.searchUser()
            },
            //名称搜索
            nameChange(val){
                this.personid=val
                let obj=this.searchPeople.find(one=>one.id==val);
                this.personname=obj?.name;
                this.currentPage=1
                this.canSave=false
                this.canEdit=false
                this.overtimeList()
                this.$forceUpdate()
            },
            searchFun(){
                this.currentPage=1
                this.canSave=false
                this.canEdit=false
                this.overtimeList()
            },
            changeMonth(){
                    this.currentPage=1
                    this.canSave=false
                    this.canEdit=false
                    this.overtimeList()

            },
            add(){
                this.canSave=true
                this.tableData.unshift({
                    // forDate:'',
                    startTime:'',
                    endTime:'',
                    overtimeHour:'',
                    overtimeType:2,
                    vc_lruname: sessionStorage.getItem("lruname"),
                    i_lruid:sessionStorage.getItem("userid"),
                    pid:0,
                    subId:0,
                    userName:this.personname,
                    userId:this.personid,
                    i_isbk:0,
                })
            },
            edit(){
                this.canSave=true
                this.canEdit=true
            },
            noedit(){
                this.canSave=false
                this.canEdit=false
            },
            editSave(){
                let list=this.tableData.filter(l=>l.change=='change')
                this.saveOvertime()

            },
            delFun(row,index){
                if(row.pid){
                    this.canSave=true
                    this.delList.push(row.subId)
                    this.tableData.splice(index,1)
                }
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.overtimeList();

            },
            //搜索查询
            async searchUser() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    keyname:this.searchname
                }
                let res = await API.searchUser(params);
                if (res.code == 1) {
                    this.searchPeople=res.data
                    // if (this.searchPeople.length==1){
                    //     this.personid= this.searchPeople[0].id
                    //     this.overtimeList()
                    //     this.$forceUpdate()
                    // }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async saveOvertime() {
                let list=this.tableData.filter(l=>l.change=='change'),cansave=true;
                for(let l of list){
                    if (!l.startTime||!l.endTime){
                        this.$message.error('请填写开始时间/结束时间');
                        cansave=false
                    };
                    if(!l.overtimeHour){
                        this.$message.error('请填写加班时长');
                        cansave=false
                    };
                };
                if(!cansave){
                    return
                }
                if(this.delList.length==0&&list.length==0){
                    this.$message.error('无更改数据');
                    return

                }
                let params = {
                    userName:this.personname,
                    userId:this.personid,
                    delSubs:this.delList,
                    sub:list,
                };
                // console.log(params,'params')
                // return
                this.canSave=false
                this.canEdit=false
                let res = await API.saveOvertime(params);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.currentPage=1
                    this.delList=[]
                   this.overtimeList()
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                    this.overtimeList()
                }
            },
            async overtimeList(){
                this.delList=[]
                // if(this.listparamid){
                let param={
                    currentPage:this.currentPage,
                    pageSize: this.pageSize,
                    forMonth:this.month,
                    userId:this.personid,
                    i_type:1,
                };
                let res=await API.overtimeList(param);
                if(res.code==1){
                    this.tableData=res.data.list;
                    this.total=res.data.total;

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
                // }else{
                //     this.$message.warning('请选择产品')
                // }

            },
            kqdataChange(val){
                // console.log(val)
                this.kqdata=val
                let kqdjmark=this.kaoqinList.filter(item=>{
                    return item.vc_tcname==val
                })
                this.djmark=kqdjmark[0].vc_djmark
                this.kaoqini_id=kqdjmark[0].i_id

            },
            async workovertime() {
                // this.formonth=data.forMonth

                let loading =this.$loading({lock:true,text:"正在加载数据,请稍候...",background:"rgba(0,0,0,0.5)"});
                // this.$refs.eDialog.showDialog({title:"报表",btn:{f:this.btn,l:{a:{title:"a",name:"a1"}}},parm:{type:'AttMonthRpt',mid:this.$route.meta.mid},w:800,h:600});
                document.addEventListener('click',function(e){
                    loading.close()
                })

                // console.log(this.i_kqtcid)
                let params = {
                    kqtcId: this.kaoqini_id,
                    date:this.month,


                }
                let res = await API.time(params);
                if (res.code == 1) {
                    // console.log(res)
                    this.startDate=res.data.monthStartTime
                    this.endDate=res.data.monthEndTime
                    this.$refs.eDialog.showDialog({title:"加班异常报表",parm:{type:'OvertimeExceptRpt',mid:this.$route.meta.mid,arg:{startDate:this.startDate,endDate:this.endDate.substring(0,10),djmark:this.djmark}},w:1024,h:768});
                    loading.close();
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});

                    this.$message.error(res.message);
                }
            },

             async workovertimeSy() {
                // this.formonth=data.forMonth

                let loading =this.$loading({lock:true,text:"正在加载数据,请稍候...",background:"rgba(0,0,0,0.5)"});
                // this.$refs.eDialog.showDialog({title:"报表",btn:{f:this.btn,l:{a:{title:"a",name:"a1"}}},parm:{type:'AttMonthRpt',mid:this.$route.meta.mid},w:800,h:600});
                document.addEventListener('click',function(e){
                    loading.close()
                })

                // console.log(this.i_kqtcid)
                let params = {
                    kqtcId: this.kaoqini_id,
                    date:this.month

                }
                let res = await API.time(params);
                if (res.code == 1) {
                    // console.log(res)
                    this.startDate=res.data.monthStartTime
                    this.endDate=res.data.monthEndTime
                    this.$refs.eDialog.showDialog({title:"加班使用明细",parm:{type:'OvertimeUseRpt',mid:this.$route.meta.mid,arg:{startDate:this.startDate,endDate:this.endDate.substring(0,10),djmark:this.djmark,i_kquid:this.personid}},w:1024,h:768});
                    loading.close();
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});

                    this.$message.error(res.message);
                }
            },
             async workovertimeZl() {
                // this.formonth=data.forMonth

                let loading =this.$loading({lock:true,text:"正在加载数据,请稍候...",background:"rgba(0,0,0,0.5)"});
                // this.$refs.eDialog.showDialog({title:"报表",btn:{f:this.btn,l:{a:{title:"a",name:"a1"}}},parm:{type:'AttMonthRpt',mid:this.$route.meta.mid},w:800,h:600});
                document.addEventListener('click',function(e){
                    loading.close()
                })

                // console.log(this.i_kqtcid)
                let params = {
                    kqtcId: this.kaoqini_id,
                    date:this.month

                }
                let res = await API.time(params);
                if (res.code == 1) {
                    // console.log(res)
                    this.startDate=res.data.monthStartTime
                    this.endDate=res.data.monthEndTime
                    this.$refs.eDialog.showDialog({title:"加班总览",parm:{type:'OvertimeSumRpt',mid:this.$route.meta.mid,arg:{startDate:this.startDate,endDate:this.endDate.substring(0,10),djmark:this.djmark,i_kquid:this.personid?this.personid:0}},w:1024,h:768});
                    loading.close();
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});

                    this.$message.error(res.message);
                }
            },
            //考勤方案接口
            async getKqList() {

                let param = {
                    i_mid: this.mid,

                };
                let res = await API.getKqList(param);
                if (res.code == 1) {
                    this.kaoqinList=res.data
                    this.kqdata=res.data[0].vc_tcname
                    let kqdjmark=this.kaoqinList.filter(item=>{
                        return item.vc_tcname==this.kqdata
                    })
                    this.kaoqini_id=kqdjmark[0].i_id
                    this.djmark=kqdjmark[0].vc_djmark
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .red{
        color: red;
    }
    .green{
        color: green;
    }
    .blue{
        color: dodgerblue;
    }
.p14{
    padding: 14px;
}
    .m-l14{
        margin-left: 14px;
    }
    .m-b9{
        margin-bottom: 9px;
    }
    .datetxt{
        font-size: 14px;
        display: inline-block;
        width: 50px;
    }
    .flex{
        display: flex;
        align-items: center;
    }
    .jcsb{
        justify-content: space-between;
    }
    /deep/{
        .el-radio{
            margin-right: 7px;
        }
    }
</style>